import ApplicationController from '../application_controller.js';
import {DataTable} from "simple-datatables"

var dataTable = null;

export default class extends ApplicationController {
  
    connect() {
        super.connect();
        let self = this;
        // Wait for stimulus to load and then refresh the data
        if (window.stimulusReady) {
          self.stimulate("Reports#refresh");
        }else {
          document.addEventListener("stimulus-reflex:connected", function(event) {
            window.stimulusReady = true;
            self.stimulate("Reports#refresh");
          });
        }
      }

      onStimulusReflexReady() {

        this.stimulate("Reports#refresh");
      }

      beforeReflex () {
        // close any open menus
        var menus = document.querySelectorAll("ul.show");
        menus.forEach(function(menu){
          menu.classList.remove("show");
        });

        // hide old data
        var reportTable = document.getElementById("reportContainer");
        reportTable.classList.add("d-none");

        // apply wait animation
        var report = document.getElementById("reportLoader");
        report.classList.remove("d-none");


      }

      afterReflex () {
        // remove wait animation and reapply datatable

        this.setupDataTable();
        this.addSortButtonLabels();
        this.addPaginationLabels();
      }
    
      addSortButtonLabels() {
        //for screenreaders to announce the sort column
        let sortLinks = document.querySelectorAll('.dataTable-sorter');
        sortLinks.forEach((link, index) => {
          link.setAttribute('aria-label', `Sort column ${index + 1}`);
        });
      }
    
      addPaginationLabels() {
        //for screenreaders to announce the page number in the table
        let paginationLinks = document.querySelectorAll('.dataTable-pagination a');
        paginationLinks.forEach((link, index) => {
          link.setAttribute('aria-label', `Go to page ${index + 1}`);
        });
      }

      setupDataTable(){
        var dataTable = new DataTable("#reportTable", {
          perPage: 15,
          perPageSelect: false,
          labels: {
            noRows: "No matches found for date range given",
            info: "Showing {start} to {end} of {rows} matches"
          }
        });

        const downloadBtn = document.getElementById("downloadReport");
        downloadBtn.addEventListener("click", function() {
          dataTable.export({
            type: 'csv', 
            filename: "TogetherlyReportExport", 
            download: true, 
            columnDelimiter: ',',
            skipColumn: [9] // skip the view match column
          });
        });

        
        this.ourSearchBar = document.getElementById('reportSearchBar');
        this.simpleDatatableSearch = document.getElementsByClassName('dataTable-input')[0];
        this.setupDataTableSearch();
      }

      setupDataTableSearch(){
        this.ourSearchBar.addEventListener('keyup', (e) => {
          this.simpleDatatableSearch.value = this.ourSearchBar.value;
          this.simpleDatatableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
        });
      }
}
